import { render, staticRenderFns } from "./diseaseStart.vue?vue&type=template&id=77869eb1&scoped=true"
import script from "./diseaseStart.vue?vue&type=script&lang=js"
export * from "./diseaseStart.vue?vue&type=script&lang=js"
import style0 from "./diseaseStart.vue?vue&type=style&index=0&id=77869eb1&prod&scoped=true&lang=css"
import style1 from "./diseaseStart.vue?vue&type=style&index=1&id=77869eb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77869eb1",
  null
  
)

export default component.exports